import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { RUNTIMES } from '@elementary/common-ui/constants/queryKeys';
import useSnackbar from 'shared/hooks/useSnackbar';
import * as api from '../api';

const useRuntimes = () => {
  const queryClient = useQueryClient();
  const { openSnackbar } = useSnackbar();

  const {
    data: runtimes = [],
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: [RUNTIMES],
    queryFn: api.getRuntimes,
  });

  const createRuntimeMutation = useMutation({
    mutationFn: (name: string) => api.createRuntime(name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RUNTIMES] });
      openSnackbar({ message: 'Runtime created', variant: 'success' });
    },
    onError: () => {
      openSnackbar({ message: 'Failed to create runtime', variant: 'error' });
    },
  });

  return {
    runtimes,
    isLoading,
    isError,
    refetch,
    createRuntime: createRuntimeMutation.mutateAsync,
    isCreating: createRuntimeMutation.isLoading,
  };
};

export default useRuntimes;
